// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// Dominio https://montacargasmasterbackdev.co
// Ip http://34.207.70.171/

export const environment = {
  production: false,
  name: "(DEV)",

  apiBaseUrl: "https://backend-prodmaster.montacargasmaster.co/",
  clientId: "65",
  clientSecret: "7peouw9r6mXGBGjL8Pe3tKVdwOtsSW4PFS00pw0Z",

  // apiBaseUrl: "https://backend-pruebas.montacargasmaster.co/",
  // clientId: "77",
  // clientSecret: "r3ePl4dE3g6J590fT9MxoYutaNnAONxetPDQ5qse",

  // apiBaseUrl: "http://127.0.0.1:8000/",
  // clientId: "81",
  // clientSecret: "GgmyYM0bq6eraoXoZZNqPxUcscBFSEs2UNVRKHMe",

  ////// Este es el que esta viejo
  // accessKeyId: "AKIAQTIVBK67FU3N4ZPV",
  // secretAccessKey: "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",
  // region: "us-east-1",

  ////// Pruebas serial pasada con sergio
  //accessKeyId: "AKIAQTIVBK67MKRVENOK",
  //secretAccessKey: "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",
  //region: "us-east-1",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts